// STEP 3 · rule 9 · B-9c (owner 26-Oct-2026 14:39) — ONE unit for a coverage figure on screen: a PERCENT, from the counts
// (eligible / total × 100). Nothing to cover (total 0 / missing) → null, shown as "Not applicable" (EN + AR, s3r9.notApplicable),
// never 0 % or 100 %. The backend twin is backend/pct.py (coverage_pct / coverage_of / fmt_pct). A result stored before the
// change holds a fraction in `coverage_pct`; the counts give the same percent, so the screens read the counts.

export function coveragePct(part, whole) {
  const p = Number(part);
  const w = Number(whole);
  if (part == null || whole == null || !Number.isFinite(p) || !Number.isFinite(w) || w <= 0) return null;
  return (p / w) * 100;
}

// "93.5 %" or the "Not applicable" text
export function fmtCoverage(pct, t) {
  if (pct == null || !Number.isFinite(Number(pct))) return t("s3r9.notApplicable");
  const v = Math.round(Number(pct) * 10) / 10;
  return `${(Object.is(v, -0) ? 0 : v).toFixed(1)} %`;   // one decimal, Western digits (a percent stays below 1,000)
}
